import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import FormListing from './FormListing';
import FormTypeSelector from './FormTypeSelector';
import EvaluationFormBuilder from './EvaluationFormBuilder';
import InputDetailFormBuilder from './InputDetailFormBuilder';
import FeedbackFormBuilder from './FeedbackFormBuilder';
// import CreateFormFromJSON from './CreateFormFromJSON';

export default function FormBuilder() {
    return (
        <Routes>
            {/* Form Listing */}
            <Route index element={<FormListing />} />

            {/* Create Form */}
            <Route path="new" element={<FormTypeSelector />} />

            {/* Builders */}
            <Route path="evaluation/:formId" element={<EvaluationFormBuilder />} />
            <Route path="input-detail/:formId" element={<InputDetailFormBuilder />} />
            <Route path="feedback/:formId" element={<FeedbackFormBuilder />} />


            {/* Fallback */}
            <Route path="*" element={<Navigate to="/form-builder" replace />} />
        </Routes>
    );
}
